module.exports = __webpack_public_path__ + "img/4aa3829.png";